import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { showMessage } from 'app/store/fuse/messageSlice';
import { constants } from '../../../../../constants';
import client from 'client';
import ModalSubscriptionsPaywalls from 'app/main/subscriptionManagement/ModalSubscriptionsPayWalls';
import { isPaywallResponse, useSubscriptionPaywall } from 'app/main/subscriptionManagement/SubscriptionPaywallContext';
import store from 'app/store';
import ButtonLog from 'app/main/ButtonLog';
import {useTranslation} from 'react-i18next';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Divider, Tooltip } from '@mui/material';
import moment from 'moment';

function JobsHelpersHeader({
  id,
  jsonGetById,
  setEditJobOpen,
  data,
  job_id,
  setEditJobBillingOpen,
  setJob_id,
  onChangeText,
  onInputText,
  bolJob,
  bolImage,
  setFakeLoad,
  setJsonGetById,
}) {
  const dispatch = useDispatch();
  const methods = useFormContext();
  const [disabled, setDisabled] = useState(false);
  const [jobtype, setJobtype] = useState(null);
  const { formState, watch, getValues, setError, reset, setValue } = methods;
  const [subscriptionsPaywalls, setSubscriptionsPaywalls] = useState(false);
  const { isValid, dirtyFields, errors } = formState;
  const name = watch('name');
  const theme = useTheme();
  const history = useHistory();
  const token = localStorage.token;
  const { notifyPastDue, blockNewJob } = useSubscriptionPaywall();

  useEffect(async () => {
    if (jsonGetById.length > 0) {
      const { job_type } = jsonGetById[0];
      setJobtype(job_type);
    }
  }, []);

  const _setError = () => {
    setError('quarry_pit');
    setError('j_destination');
    setError('j_fullfillment_warning');
  };

  const clearForm = {
    job_c_id: [],
    quarry_pit: [],
    j_destination: [],
    j_fullfillment_warning: null,
    j_fullfillment_total: null,
    j_notes: '',
    j_notes_drivers: '',
    po: null,
    j_status: true,
    scale: true,
  };

  const _showMessage = (msg, color) => {
    dispatch(
      showMessage({
        message: msg, //text or html
        autoHideDuration: 6000, //ms
        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: color, //success error info warning null
      })
    );
  };

  async function handleUpdateJob() {
    try {
      if (bolJob) {
        if (!bolImage) {
          _showMessage(t('PLEASE_UPLOAD_A_BILL_OF_LADING'), 'error');
          return;
        }
      }

      if (!getValues().j_destination) {
        setValue('l_name', onInputText);
        setValue('route', null);
      }

      if (onChangeText != onInputText) {
        setValue('l_name', onInputText);
        setValue('route', null);
        setValue('j_destination', null);
      }

      if (getValues('j_fullfillment_warning') == '') {
        setValue('j_fullfillment_warning', null);
      }

      if (getValues('j_fullfillment_total') == '') {
        setValue('j_fullfillment_total', null);
      }

      setDisabled(true);
      // console.log(getValues());
      // if (!getValues('visibility')) {
      //   setValue('visibility', getValues('visibility') ? false : true);
      // }

      // console.log('getValues()', getValues());

      // return;
      setValue('bol_type', bolJob);
      bolJob ? setValue('bol_file', JSON.stringify(bolImage)) : null;
      console.log('getValues()', getValues());
      try {
        ButtonLog({
          button_name: 'update_job',
          type: 'job',
          info: `job id: ${job_id ? job_id : id}, ` + `${JSON.stringify(getValues())}`,
        });
      } catch (error) {
        console.log(('BUTTON LOG ERROR CONTINUE: ', error));
      }

      const response = await client.put(`/jobs/update-job/${job_id ? job_id : id}`, getValues());
      const res = await response.data;

      // _showMessage(`The job with number ${getValues('job_no')} has been updated correctly!`, 'success')
      _showMessage(t('JOB_UPDATED_SUCCESSFULLY'), 'success'); //TODO improved message

      if (res.error) {
        _showMessage(t('THERE_WAS_AN_ISSUE_UPDATING_THE_JOB'), 'error'); //TODO improved message
        setDisabled(false);
        return;
      }

      reset(clearForm);
      setDisabled(false);
      _setError();
      data ? setEditJobOpen(false) : history.push('/jobs');
    } catch (error) {
      console.log(error);
      _showMessage(t('THERE_WAS_AN_ISSUE_UPDATING_THE_JOB'), 'error'); //TODO improved message
      setDisabled(false);
    }
  }

  async function handleSaveJob() {
    if (blockNewJob()) {
      return;
    }
    try {
      if (bolJob) {
        if (!bolImage) {
          _showMessage(t('PLEASE_UPLOAD_A_BILL_OF_LADING'), 'error');
          return;
        }
      }

      if (!getValues().j_destination) {
        setValue('l_name', onInputText);
        setValue('route', null);
      }

      if (onChangeText != onInputText) {
        setValue('l_name', onInputText);
        setValue('route', null);
        setValue('j_destination', null);
      }

      if (getValues('j_fullfillment_warning') == '') {
        setValue('j_fullfillment_warning', null);
      }

      if (getValues('j_fullfillment_total') == '') {
        setValue('j_fullfillment_total', null);
      }

      setValue('bol_type', bolJob);
      bolJob ? setValue('bol_file', JSON.stringify(bolImage)) : null;
      //console.log('getValues()', getValues());

      setDisabled(true);
      const response = await client.post(`/jobs/new${data ? `/${data.id}` : ''}`, getValues());
      const res = await response.data;

      if (res.msg) {
        _showMessage(res.msg, 'error');
        return;
      }

      _showMessage(
        `${t('JOB_HASTAG')}${res && res.length > 0 ? res[0].job_no : null} ${t('HAS_BEEN_SUCCESSFULLY_CREATED')}`,
        'success'
      ); //TODO improved message


      if(localStorage.getItem('job_duplicate'))
      {
        const job_duplicate = JSON.parse(localStorage.getItem('job_duplicate'));
        job_duplicate[0] = {...job_duplicate[0],...res[0],duplicate_from:job_duplicate[0].job_no}
        localStorage.setItem('job_duplicate', JSON.stringify(job_duplicate));
        //setJsonGetById(job_duplicate);
      }

      reset(clearForm);
      setDisabled(false);
      _setError();
      data ? handleSaveJobOpen(res) : history.push('/jobs/billing/new/' + res[0].job_info_id);
    } catch (error) {
      console.log(error);
      if (isPaywallResponse(error?.response?.data)) {
        _showMessage(error.response.data.message, 'error');
        paywallSubscriptions();
        return;
      }
      _showMessage(t('THERE_WAS_AN_ISSUE_SAVING_THE_JOB'), 'error'); //TODO improved message
      setDisabled(false);
    }
  }

  function handleSaveJobOpen(res) {
    console.log('RES', res);
    setEditJobBillingOpen(true);
    setEditJobOpen(false);
    setJob_id(res[0].job_info_id);
  }

  async function handleJobBilling() {
    if (id || job_id) {
      try {
        if (!getValues().j_destination) {
          setValue('l_name', onInputText);
          setValue('route', null);
        }

        if (onChangeText != onInputText) {
          setValue('l_name', onInputText);
          setValue('route', null);
          setValue('j_destination', null);
        }

        setDisabled(true);
        if (!getValues('visibility')) {
          setValue('visibility', jsonGetById[0].visibility);
        }

        if (bolJob) {
          if (!bolImage) {
            _showMessage(t('PLEASE_UPLOAD_A_BILL_OF_LADING'), 'error');
            return;
          }
        }

        setValue('bol_type', bolJob);
        bolJob ? setValue('bol_file', JSON.stringify(bolImage)) : null;
        console.log('getValues()', getValues());

        const response = await fetch(
          `${constants.URLLOCAL}/jobs/update-job/${job_id ? job_id : id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              token: `${token}`,
            },
            body: JSON.stringify(getValues()), // body data type must match "Content-Type" header
          }
        );
        const res = await response.json();

        //_showMessage(`The job with number ${getValues('job_no')} has been updated correctly!`, 'success')
        _showMessage(t('JOB_DETAILS_HAVE_BEEN_SUCCESSFULLY_UPDATED'), 'success'); //TODO improved message
        if (res.error) {
          _showMessage(
            t('FAILED_TO_UPDATE_THE_JOB_MESSAGE'),
            'error'
          ); //TODO improved message
          setDisabled(false);
          return;
        }

        reset(clearForm);
        setDisabled(false);
        _setError();
        data ? handleJobBillingOpen() : history.push('/jobs/billing/by-id/' + id);
      } catch (error) {
        console.log(error);
        _showMessage(t('THERE_WAS_AN_UNEXPECTED_ERROR_MESSAGE'), 'error'); //TODO improved message
        setDisabled(false);
      }
    } else {
      data ? handleJobBillingOpen() : history.push('/jobs/billing/new/' + id);
    }
    //id ? history.push('/jobs/billing/by-id/' + id) : history.push('/jobs/billing/new/' + id)
  }

  function handleJobBillingOpen() {
    setEditJobOpen(false);
    setEditJobBillingOpen(true);
  }

  const paywallSubscriptions = () => {
    setSubscriptionsPaywalls(true);
  };
  const {t} = useTranslation('navigation');

  return (
    <>
      {subscriptionsPaywalls ? (
        <ModalSubscriptionsPaywalls
          paywallSubscriptions={paywallSubscriptions}
          open={subscriptionsPaywalls}
          setSubscriptionsPaywalls={setSubscriptionsPaywalls}
          compacctnum={store.getState().loadz_auth.AuthReducer.user.company.compacctnum}
        ></ModalSubscriptionsPaywalls>
      ) : null}

      <div className='flex flex-1 w-full items-center justify-between job-edit-form pb-44 px-0 pt-0'>
        <div className='flex flex-col items-start max-w-full min-w-0'>
          <motion.div
            initial={{ x: 20, opacity: 0 }}
            animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
          >
            {data ? (
              <Typography
                className='flex items-center sm:mb-12'
                role='button'
                color='black'
                onClick={() => {
                  setEditJobOpen(false);
                  setEditJobBillingOpen(false);
                  setJob_id('');
                }}
              >
                <Icon className='text-20'>
                  {theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}
                </Icon>
                <span className='sm:flex mx-4 font-medium'>{t('BACK_TO_JOBS_OVERVIEW')}</span>
              </Typography>
            ) : (
              <Typography
                className='flex items-center sm:mb-12'
                component={Link}
                role='button'
                to='/jobs'
                color='black'
              >
                <Icon className='text-20'>
                  {theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}
                </Icon>
                <span className='sm:flex mx-4 font-medium'>{t('BACK_TO_JOBS_OVERVIEW')}</span>
              </Typography>
            )}
          </motion.div>

          <div className='flex items-center max-w-full'>
            <div className='flex flex-col min-w-0 mx-8 sm:mc-16'>
              <motion.div initial={{ x: -20 }} animate={{ x: 0, transition: { delay: 0.3 } }}>
                <Typography variant='h4' color='black' className='font-bold'>
                  {
                    localStorage.getItem('job_duplicate') ? 
                    'Creating Duplicate Job'
                    :
                  id || job_id
                    ? `${t('UPDATE_JOB_NO')} ${
                        jsonGetById && jsonGetById.length > 0 ? jsonGetById[0].job_no : null
                      }`
                    : bolJob
                    ? t('CREATE_A_BILL_OF_LADING')
                    : 
                    t('ADD_JOB')}
                </Typography>
              </motion.div>
              {
                localStorage.getItem('job_duplicate') ?
                <div className='flex flex-col mt-16 w-full' >
                  <Divider></Divider>
                  <div className='flex flex-row w-full justify-start items-center'>
                    <Icon sx={{fontSize:'22px !important'}}>info</Icon>
                    <Typography variant='caption' className='job-billing pl-8' color='black'>
                      This is a duplicate
                    </Typography>
                  </div>
                  <Typography variant='caption' className='job-billing ml-16' color='black'>
                    This job is a duplicate of Job No. {JSON.parse(localStorage.getItem('job_duplicate'))[0].job_no}
                  </Typography>
                  <Divider></Divider>

                </div>
                :null
              }
              
            </div>
            {
              jsonGetById && jsonGetById.length > 0  && (id || job_id) ? 
              <Tooltip title='Duplicate Job'>
                <Button
                 
                  className="whitespace-nowrap"
                  sx={{color:'black',padding:0,justifyContent:'start'}}
                  onClick={() => {
                    setFakeLoad(true);
                    ButtonLog({button_name: 'duplicate_job', type: 'job', info: `job id: ${job_id ? job_id : id}, ` + `${JSON.stringify(jsonGetById)}`});
                    setTimeout(() => {
                      setFakeLoad(false);
                      localStorage.setItem('job_duplicate', JSON.stringify(jsonGetById));
                      localStorage.setItem('job_duplicate_date', moment().format());
                      history.push('/jobs/new');
                      _showMessage('Duplicating Job No. '+store.getState().loadz_auth.AuthReducer.user.company.company_id+"-"+jsonGetById[0].job_no,'success');
                    }, 1000);
                  }}
                >
                  <ContentCopyIcon fontSize='small' color='black'/>
                </Button>
              </Tooltip>
              :
              null
            }
          </div>
        </div>
        <motion.div
          className='flex job-edit-form-btns custom-update-btn'
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}
        >
          {(id || job_id) && (
            <Button
              style={{ color: 'white' }}
              className='whitespace-nowrap mx-4'
              variant='contained'
              color='third'
              onClick={handleJobBilling}
            >
              {id || job_id ? t('UPDATE_JOB_BILLING') : t('CREATE_JOB_BILLING')}
            </Button>
          )}

          <Button
            style={{ color: 'black', background: 'none' }}
            disabled={jobtype == 'sub' ? true : false}
            className='whitespace-nowrap mx-0 p-0'
            variant='contained'
            color='third'
            onClick={id || job_id ? handleUpdateJob : handleSaveJob}
          >
            {id || job_id ? t('UPDATE') : t('SAVE_AND_CONTINUE')}
            <Icon className='text-20 ml-5'>
              {''}
              {'arrow_forward'}
            </Icon>
          </Button>
        </motion.div>
      </div>
    </>
  );
}

export default JobsHelpersHeader;
